module.exports = __webpack_public_path__ + "static/media/Risa coverage in Surfaces Magazine.150d69f2.png";